import { flatMap, uniq } from 'lodash';
import { downloadExcelFromJson } from './fileGeneration';
import { SnackbarSeverityType } from '../enums';

type ShowToastType = (message: string, severity: SnackbarSeverityType) => void;

export const downloadReport = (
  reportData: any[],
  fileName: string,
  sheetName: string,
  showToast: ShowToastType
) => {
  try {
    if (!reportData || reportData.length === 0) {
      showToast(
        `No data available to download ${sheetName}`,
        SnackbarSeverityType.success
      );
      return;
    }

    const headers = uniq(
      flatMap(reportData, (obj: Record<string, any>) => Object.keys(obj))
    ) as unknown as string[];
    const body = reportData.map((row: Record<string, any>) =>
      headers.map((header) => row[header] || '')
    );

    downloadExcelFromJson(fileName, sheetName, {
      headers,
      body
    });

    showToast(
      `${sheetName} report downloaded successfully.`,
      SnackbarSeverityType.success
    );
  } catch (error) {
    console.error(`Failed to download ${sheetName}:`, error);
    showToast(`Failed to download ${sheetName}`, SnackbarSeverityType.error);
  }
};
